import Glide from '@glidejs/glide'
import {resize} from "./tools/resize";
import {heights} from "./tools/heights";
import {applyMatchHeight, matchHeight} from "./tools/matchheight";
import {details_extra, filters, set_active_filters} from "./components/filters";
import {SetActiveBulletInstantly} from "./tools/glide.bullet-instantly";
// scroll top menu
document.addEventListener("DOMContentLoaded", function () {
  var scrollObject = {};
  window.onscroll = getScrollPosition;
  const main = document.getElementById('header');

  function getScrollPosition() {
    scrollObject = {
      x: window.pageXOffset,
      y: window.pageYOffset
    }
    if (scrollObject.y > 80) {
      main.classList.add('is-active');
    } else {
      main.classList.remove('is-active');
    }
  }

// Nav mobile
  const body = document.body;
  const navicon = document.getElementById('navicon');
  const nav = document.getElementById('main-nav');
  navicon.onclick = function () {
    if (navicon.classList.contains('active')) {
      navicon.classList.replace('active', 'passive');
      body.classList.toggle('nav-open');
      nav.classList.toggle('active');
    } else {
      navicon.classList.replace('passive', 'active');
      body.classList.toggle('nav-open');
      nav.classList.toggle('active');
    }
  }

  const btnMenu = nav.querySelectorAll(`a[href^="#"]:not([href="#"])`);

  btnMenu.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      nav.classList.remove('active')
      body.classList.remove('nav-open')
      navicon.classList.replace('active', 'passive')
    });
  })

// Slider testimonials
  let testimonials = document.getElementById('testimonials');
  if (testimonials) {
    let glide = new Glide('#testimonials', {
      type: 'carousel',
      perView: 3,
      rewind: false,
      keyboard: true,
      gap: 30,
      autoPlay: 2000,
      animationDuration: 1200,
      breakpoints: {
        1600: {
          gap: 20,
        },
        1199: {
          perView: 3,
        },
        991: {
          perView: 2,
          gap: 20,
        },
        768: {
          perView: 1,
        },
        480: {
          perView: 1,
        }
      }
    });
    glide.mount()
  }

  let sliderGallery = document.getElementById('slider-gallery');
  if (sliderGallery) {
    let glide = new Glide('#slider-gallery', {
      type: 'slider',
      perView: 2,
      rewind: false,
      gap: 20,
      keyboard: true,
      autoPlay: 2000,
      animationDuration: 1200,
      breakpoints: {
        768: {
          perView: 2,
        },
        480: {
          perView: 1,
        }
      }
    });
    glide.mount()
  }

  const gallery_functionnalty = document.querySelectorAll('.functionality-gallery');
  if (gallery_functionnalty.length > 0) {

    gallery_functionnalty.forEach(gallery => {
      if (gallery.querySelectorAll('.glide__slide').length > 1) {
        let gallery_glide = new Glide(gallery, {
          perView: 1,
          type: 'carousel',
          rewind: false,
        });
        gallery_glide.mount()
      }
    })
  }


  const partners = document.querySelectorAll('.partners__list');
  if (partners.length > 0) {
    partners.forEach(partner => {
      let partners_glide = new Glide(partner, {
        type: 'carousel',
        perView: 6,
        rewind: false,
        gap: 20,
        hoverpause: false,
        autoplay: 2000,
        breakpoints: {
          768: {
            perView: 2,
          },
          480: {
            perView: 2,
          }
        }
      });
      partners_glide.mount()
    })
  }

  const playButtons = document.querySelectorAll('.btn-play-video');

  playButtons.forEach(button => {
    button.addEventListener('click', function (e) {
      e.preventDefault();

      const videoId = this.id + '-item';
      const currentVideo = document.getElementById(videoId);
      const allVideos = document.querySelectorAll('.video-item');
      button.classList.toggle('is-playing');
      allVideos.forEach(video => {
        if (video !== currentVideo && !video.paused) {
          video.pause();
          video.currentTime = 0;
          video.closest('div').querySelector('.btn-play-video').classList.remove('is-playing');
        }
      });
      if (currentVideo.paused) {
        currentVideo.play();
        console.log('should play')
        button.classList.add('is-playing');
      } else {
        currentVideo.pause();
        button.classList.remove('is-playing');
      }
    });
  });

// Slider PME services
  let sliderFeatures = document.getElementById('slider-features');
  if (sliderFeatures) {

    let glide = new Glide('#slider-features', {
      type: 'slider',
      perView: 1,
      rewind: false,
      focusAt: 'center',
      keyboard: true,
      gap: 20,
      animationDuration: 1200,
    });

    glide.mount({SetActiveBulletInstantly});
  }


// animation transition
// is in viewport
  var isInViewport = function (elem) {
    var distance = elem.getBoundingClientRect();
    return (
      distance.bottom >= 0 &&
      distance.left >= 0 &&
      distance.top <= document.documentElement.clientHeight - 50
      // &&
      // distance.right <=
      // (window.innerWidth || document.documentElement.clientWidth)
    );
  };

  var iivps = document.querySelectorAll([".animate"]);
  iivps.forEach((item) => {
    window.addEventListener("scroll", function (event) {
      if (isInViewport(item)) {
        item.classList.add("is-visible");
      }
    });
    window.addEventListener("load", function (event) {
      if (isInViewport(item)) {
        item.classList.add("is-visible");
      }
    });
  });

  iivps.forEach((item) => {

    if (isInViewport(item)) {
      item.classList.add("is-visible");
    }
  });

//faq collapse
  var coll = document.getElementsByClassName("collapsible");
  var i;

  for (i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = content.scrollHeight + "px";
      }
    });
  }

  /**
   * Button width fix
   */
  const button_filter_width = () => {
    document.querySelectorAll('.btn-filter input:checked').forEach(input => {
      set_active_filters(input);
    })
  };


  /**
   * Set important height on
   */
  matchHeight(
    '.usp--list__item',
    '.formules-table--cell',
    '.formules-table__header',
    '.formule-card__header'
  )
  resize(
    heights,
    applyMatchHeight,
    button_filter_width
  )

  filters();
  details_extra();
});
